"use strict";

var _defineProperty = require("/codebuild/output/src2730718938/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    root: {
      '&.MuiButton-containedPrimary': {
        color: isHighContrast ? 'rgba(0, 0, 0, 0.75)' : '#fff'
      },
      '&.submit': _defineProperty({
        fontSize: isFontBigger ? 21 : 18,
        fontWeight: 700,
        height: 52,
        maxWidth: 256,
        width: '100%'
      }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
        maxWidth: 'unset'
      }),
      borderRadius: 30
    }
  };
};
exports.default = _default;